import {
    dictionary,
    locale,
    _
} from 'svelte-i18n';
function setupI18n({ withLocale: _locale} = { withLocale: 'en-US' }) {
    dictionary.set({
        'en-US': {
            'addCommentTitle': 'New comment',
            'yourNamePlaceholder': 'Your name',
            'yourEmailPlaceholder': 'Your email',
            'messagePlaceholder': 'Message text',
            'savePersonalDataCheckbox': 'Save my name and email for further usage',
            'saveCommentLabel': 'Add comment',
            'commentsListTitle': 'Comments',
            'allFieldsAreRequiredError': 'All fields are required!',
            'commentIsWaitingForModeration': 'Comment is waiting for moderation...',
        },
        'ru-RU': {
            'addCommentTitle': 'Добавить комментарий',
            'yourNamePlaceholder': 'Ваше имя',
            'yourEmailPlaceholder': 'Ваша почта',
            'messagePlaceholder': 'Введите текст',
            'savePersonalDataCheckbox': 'Сохранить моё имя и e-mail в этом браузере для последующих моих комментариев',
            'saveCommentLabel': 'Оставить комментарий',
            'commentsListTitle': 'Комментарии',
            'allFieldsAreRequiredError': 'Все поля обязательны для заполнения!',
            'commentIsWaitingForModeration': 'Комментарий ожидает модерацию...',
        },
    });
    locale.set(_locale);
}
export {
    _,
    setupI18n
};